import ManageUsers from '../../components/ManageUsers';
import React from 'react';

const UsersPage = () => <ManageUsers />;

export default UsersPage;
